import { useMutation, useQueryClient } from 'react-query';
import { ChangeOrderService as co } from '../api/ChangeOrderService';
import { ChangeOrder } from '../api/protosCompiled/changeOrder/changeOrder_pb';
import { useStore } from 'zustand';
import { useUnityBuildStore } from '../stores/store';

export const useCreateChangeOrderMutation = () => {
  const queryClient = useQueryClient();
  const { selectedProject } = useStore(useUnityBuildStore);

  return useMutation(
    (data: ChangeOrder.AsObject) => {
      return co.createChangeOrder(data);
    },
    {
      onSuccess: (result, data) => {
        // Invalidate the specific query for this contract and estimate
        if (data.contractid && data.estimateid) {
          queryClient.invalidateQueries(['changeOrders', data.contractid, data.estimateid]);
        }
        queryClient.invalidateQueries(['contracts', selectedProject?.id]);
      },
      onError: error => {
        console.error('Error creating change order', error);
      },
    }
  );
};

export const useUpdateChangeOrderMutation = () => {
  const queryClient = useQueryClient();
  const { selectedProject } = useStore(useUnityBuildStore);
  return useMutation(
    (data: ChangeOrder.AsObject) => {
      return co.updateChangeOrder(data);
    },
    {
      onSuccess: (result, data) => {
        // Invalidate the specific query for this contract and estimate
        if (data.contractid && data.estimateid) {
          queryClient.invalidateQueries(['changeOrders', data.contractid, data.estimateid]);
        }
        queryClient.invalidateQueries(['contracts', selectedProject?.id]);
      },
      onError: error => {
        console.error('Error updating change order', error);
      },
    }
  );
};

export const useDeleteChangeOrderMutation = () => {
  const queryClient = useQueryClient();
  const { selectedProject } = useStore(useUnityBuildStore);

  return useMutation((data: ChangeOrder.AsObject) => co.deleteChangeOrder(data.changeorderid), {
    onSuccess: (result, data) => {
      queryClient.invalidateQueries(['changeOrders', data.contractid, data.estimateid]);
      queryClient.invalidateQueries(['contracts', selectedProject?.id]);
    },
    onError: error => {
      console.error('Error deleting change order', error);
    },
  });
};
